import { CommentItemType } from "../../../../createEscalation.models";

export const COMMENT_ITEM_TITLE_MAP: Record<CommentItemType, string> = {
    [CommentItemType.DRAFT_COMMENT]: 'Add a comment',
    [CommentItemType.ESCALATION_RAISED]: 'Escalation Raised',
    [CommentItemType.EMAIL_SENT]: 'Email Sent',
    [CommentItemType.COMMENT_ADDED]: 'Comment Added',
    [CommentItemType.STATUS_CHANGED]: 'Status Changed',
};